import PropTypes from 'prop-types'

import useDialogDismiss from '../../../../shared/useDialogDismiss'

import styles from './style.module.scss'

/**
 * Ein Fenster für die öffentliche Kursseite.
 *
 * Bewusst nicht `UI/BaseModal`: Das hängt am Ereignisbus und an der
 * angemeldeten Anwendung — hier steht eine Seite, die auch ohne Anmeldung
 * funktionieren muss. Was das Fenster können muss, ist wenig: Klick daneben
 * und Esc schließen es (`useDialogDismiss`, dieselbe Regel wie überall).
 */
export default function CourseDialog({ onClose, kicker, title, children, actions }) {
	const dismiss = useDialogDismiss(onClose)

	return (
		<div className={styles.overlay} onMouseDown={dismiss.onMouseDown} onMouseUp={dismiss.onMouseUp}>
			<div className={styles.dialog} role="dialog" aria-modal="true" aria-label={title}>
				<button type="button" className={styles.dialogClose} onClick={onClose} aria-label="Schließen">
					×
				</button>

				{kicker && <span className={styles.dialogKicker}>{kicker}</span>}
				<h2 className={styles.dialogTitle}>{title}</h2>
				<div className={styles.dialogBody}>{children}</div>
				<div className={styles.dialogActions}>{actions}</div>
			</div>
		</div>
	)
}

CourseDialog.propTypes = {
	onClose: PropTypes.func.isRequired,
	kicker: PropTypes.string,
	title: PropTypes.string.isRequired,
	children: PropTypes.node,
	actions: PropTypes.node
}
